import { render, staticRenderFns } from "./PanelCustomerCollect.vue?vue&type=template&id=00ad15d2&scoped=true&"
import script from "./PanelCustomerCollect.vue?vue&type=script&lang=ts&"
export * from "./PanelCustomerCollect.vue?vue&type=script&lang=ts&"
import style0 from "./PanelCustomerCollect.vue?vue&type=style&index=0&id=00ad15d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ad15d2",
  null
  
)

export default component.exports